<template>
  <div class="view container">
    <el-row :gutter="20" type="flex">
      <el-col :xs="24">
        <h1 class="font--bigger m-t-0 c-black">
          <span>{{ $t('FAQ') }}</span>
        </h1>
      </el-col>
    </el-row>

    <el-row>
      <el-col :xs="24" v-loading="isLoading">
        <el-card class="m-b-1" :body-style="{ padding: '0' }" v-for="faq in faqs" :key="faq.id">
          <Accordion>
            <template v-slot:headline>{{ faq.title }}</template>
            <template v-slot:content>
              <div class="p-1 p-t-0" v-html="faq.body"></div>
            </template>
          </Accordion>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Accordion from '@/components/List/Accordion.vue';

export default {
  name: 'FAQ',

  components: {
    Accordion
  },

  computed: {
    faqs() {
      return this.$store.state.faq.all;
    }
  },

  data() {
    return {
      isLoading: false
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.requestFAQs();
    },

    requestFAQs() {
      this.isLoading = true;
      this.$store
        .dispatch('faq/GET_FAQS')
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
